import { 
  Box,
  CircularProgress
} from "@mui/material";

const CountdownTimer = ({ progress, label, className }) => {
  return (
    <Box className={`relative inline-flex ${className}`}>
      <CircularProgress variant="determinate" value={progress} size={32}/>
      <Box className='top-0 left-0 bottom-0 right-0 absolute flex items-center justify-center'>
        <span className='text-xs font-normal'>
          {label}
        </span>
      </Box>
    </Box>
  )
}

export default CountdownTimer;